export default __webpack_public_path__ + "static/media/es-ca.2b2d073d.svg";